import "./App.css";
import PaymentPage from "./PaymentPage";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/pay" element={<PaymentPage />} />
      </Routes>
    </div>
  );
}

export default App;